module.exports = __webpack_public_path__ + "static/media/people.c528da6d.svg";